import { ApiClientService, StorageService } from "@dfl/react-security";
import { LANGUAGE_INPUT } from "components/LanguageInputMenu/LanguageMenu";


//@ts-ignore
export const LangInterceptor = ApiClientService.service.interceptors.request.use(function (config) {
  const lang = StorageService.getItem(LANGUAGE_INPUT)
  if (!!lang) {
    //@ts-ignore
    config.headers['Accept-Language'] = lang || 'es'
  }
  return config;
}, function (error: any) {
  return Promise.reject(error);
});